//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,selene: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const seleneResultsetData = data['seleneResultset']
    formData.isInvalidDoc = seleneResultsetData['is_invalid_doc']?seleneResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = seleneResultsetData['is_override_vendor_name']?seleneResultsetData['is_override_vendor_name']:false
    
    if (seleneResultsetData['vendor_id']){
        formData.vendorId = seleneResultsetData['vendor_id']
    }
    if (seleneResultsetData['vendor_name']){
        formData.vendorName = seleneResultsetData['vendor_name']
    }
    if (seleneResultsetData['inv_no']){
        formData.invNo = seleneResultsetData['inv_no']
    }
    if (seleneResultsetData['inv_date']){
        formData.invDate = seleneResultsetData['inv_date']
    }
    if (seleneResultsetData['po_no']){
        formData.poNo = seleneResultsetData['po_no']
    }
    if (seleneResultsetData['acct_no']){
        formData.acctNo = seleneResultsetData['acct_no']
    }
    if (seleneResultsetData['project_no']){
        formData.projectNo = seleneResultsetData['project_no']
    }
    if (seleneResultsetData['terms']){
        formData.terms = seleneResultsetData['terms']
    }
    if (seleneResultsetData['tax']){
        formData.tax = parseFloat(seleneResultsetData['tax'])
    }
    if (seleneResultsetData['additional']){
        formData.additional = parseFloat(seleneResultsetData['additional'])
    }
    if (seleneResultsetData['total']){
        formData.total = parseFloat(seleneResultsetData['total'])
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/selene/editFormData.js